import { render, staticRenderFns } from "./StockOpname.vue?vue&type=template&id=6aa0d2e0&scoped=true"
import script from "./StockOpname.vue?vue&type=script&lang=js"
export * from "./StockOpname.vue?vue&type=script&lang=js"
import style0 from "./StockOpname.vue?vue&type=style&index=0&id=6aa0d2e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa0d2e0",
  null
  
)

export default component.exports